import CheckIcon from '@mui/icons-material/Check';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { getJiraAuthUrl } from '../../modules/users';
import { jiraIntegrationBenefits } from '../../static/common';
import JiraIcon from '../../assets/icons/jira.svg';
import { useParams } from 'react-router-dom';

const IntegrationOptions = ({ isAdmin }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { projectId } = useParams();

  const handleConnectToJira = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await getJiraAuthUrl('new', projectId);
      window.location.href = response;
    } catch (error) {
      setError('Failed to connect to Jira. Please try again.');
      setLoading(false);
    }
  };

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} sm={8} md={6}>
        <Card variant="outlined" sx={{ textAlign: 'center', p: 2 }}>
          <CardContent>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                mb: 3,
                justifyContent: 'center',
              }}>
              <img
                src={JiraIcon}
                alt="Jira Logo"
                style={{ width: 35, height: 35, marginRight: 8 }}
              />
              <Typography variant="h4" fontWeight="bold">
                JIRA
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Connect your Jira project to streamline ticket management and
              enhance collaboration.
            </Typography>
            <>
              {loading ? (
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  sx={{ mt: 4 }}>
                  <CircularProgress size={30} />
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 2 }}>
                    Connecting to Jira...
                  </Typography>
                </Box>
              ) : (
                <>
                  <List sx={{ mb: 3 }}>
                    {jiraIntegrationBenefits.map((text) => (
                      <ListItem key={text} disableGutters>
                        <ListItemIcon>
                          <CheckIcon color="primary" />
                        </ListItemIcon>
                        <Typography variant="body2">{text}</Typography>
                      </ListItem>
                    ))}
                  </List>

                  {error && (
                    <Typography variant="body2" color="error" sx={{ mb: 2 }}>
                      {error}
                    </Typography>
                  )}
                  {isAdmin ? (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleConnectToJira}
                      disabled={loading}
                      sx={{ mt: 2, px: 4 }}>
                      {loading ? 'Connecting...' : 'Connect to Jira'}
                    </Button>
                  ) : (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 3 }}>
                      Please contact your admin to enable Jira integration.
                    </Typography>
                  )}
                </>
              )}
            </>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default IntegrationOptions;
